/**Import react section */
import React, { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { downloadPackingListReport, updateEmailsContactNoPrice } from '../../store/sparePartSales/sparePartSalesAction'

import { sparePartSaleShowSelector } from '../../store/sparePartSales/sparePartSalesSelectors'
/**Import componenst secytion */
import OpenDesktopView from './components/OpenDesktopView'
import Toaster from '../common/Toaster'
import PanelImportSparePart from './components/PanelImportSparePart'
import Edit from './Edit'
import EditSpareCustomer from './EditSpareCustomer'

/**Import actions section */
import {
	getSparePartSales,
	addSpartPartInRequest,
	importSparePartFromBackend,
	addFilesSparePartSales,
	removeFilesInSparePartSales,
	removeSparePartDetail,
	updateSparePartSales,
	updateSpareaPartDetail,
	loadSparePartByCustomer,
	updateSparePartsPrices,
	checkShipping,
	addPartialityInRequest,
	bulkUpdatePoNumberReference,
	TRACKING_LOOKUP
} from '../../store/sparePartSales/sparePartSalesAction'

import { isNullOrEmpty } from '../../store/helpers/StringHelper'
import { buildAddFeedbackMessage, buildImportSubstitutionSummary } from '../../store/helpers/SubstitutionFeedbackHelper'
import { isDeliveredStatus } from '../../store/helpers/sparePartsStatusColors'
import { loadInternalUsers } from '../../store/users/UsersActions'
import { SPARE_PARTS_IMBERA_USA, SPARE_PARTS_IMBERA_MX, PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN } from '../../resources/RolesEnum'
import { getEmailInternalUsersByRole } from '../../store/helpers/UserHelper'
import { toSafeObject } from '../../store/helpers/StateHelper'

// Parent-only fields that the backend cascades to every child (SparePartSalesRequest.CascadePropertyToChildren).
// Matched case-insensitively since each caller in SparePartList.js sends its own casing ('POSITION', 'PoNumber', ...).
const CASCADED_PARENT_PROPERTIES = ['POSITION', 'PONUMBER', 'REFERENCESAP', 'WAREHOUSE']

// How often the open order asks the backend again for its tracking status.
//
// Chosen long on purpose. The value being chased changes a handful of times per shipment per day,
// so a short interval multiplies requests against the backend to win seconds on a column nobody
// watches by the second. The visibility trigger is what covers immediacy: coming back to the tab
// refreshes at once, so the interval only has to catch the user who never leaves.
const TRACKING_REFRESH_INTERVAL_MS = 60000

const OpenManual = (props) => {
	/**Section hooks */
	let match = useRouteMatch()
	const dispatch = useDispatch()
	const token = match.params.token
	const history = useHistory()
	/**store from redux store */
	const isLoading = useSelector((state) => state.sparePartSales.getIn(['show', 'isLoading']))
	const isDownloadReport = useSelector((state) => state.sparePartSales.getIn(['index', 'isDownloadReport']))
	const userProfile = useSelector((state) => state.session.get('profile'))
	const isSaving = useSelector((state) => state.sparePartSales.getIn(['show', 'isSaving']))
	const isGetStock = useSelector((state) => state.sparePartSales.getIn(['show', 'isGetStock']))
	const internalUsers = useSelector((state) => toSafeObject(state.users.get('internalUsers')))
	const sparePartsOptions = useSelector((state) => state.sparePartSales.get('sparePartSelector'))
	const isSavingDraft = useSelector((state) => state.sparePartSales.getIn(['create', 'isSavingDraft']))
	const isGettingTrackingData = useSelector((state) => state.sparePartSales.getIn(['show', 'isGettingTrackingData']))
	const carrierData = useSelector((state) => state.sparePartSales.getIn(['show', 'carrier']))
	let emailsInternalUsers = getEmailInternalUsersByRole(
		[SPARE_PARTS_IMBERA_MX, SPARE_PARTS_IMBERA_USA, PORTAL_ADMINISTRATOR, DISPATCHER, IMBERA_TECHNICIAN],
		internalUsers
	)

	/**Store local this component */
	const showSpareRequestSale = useSelector(sparePartSaleShowSelector)
	const [toaster, setToaster] = useState({
		open: false,
		variant: null,
		message: null
	})
	const [addLateralPanelConfig, setAddLateralPanelConfig] = useState({
		opened: false
	})

	const [identifierSparePartDelete, setIdentifierSparePartDelete] = useState('')
	const [isSavingBulkPoReference, setIsSavingBulkPoReference] = useState(false)
	const [lateralPanelStatusConfig, setLateralPanelStatusConfig] = useState({ opened: false, spartPart: null })
	const [lateralPanelImportFile, setLateralPanelImportFile] = useState({ opened: false })
	const [editLateralPanelConfig, setEditLateralPanelConfig] = useState({ opened: false, part: null })
	const [lateralPanelCustomerConfig, setLateralPanelCustomerConfig] = useState({ opened: false, spartPart: null })

	/**
	 * Pulls the order again after a line's status is saved, without disturbing the screen.
	 *
	 * The status is saved against one line, but the backend recomputes things this view shows
	 * beyond that line, so the order has to be read again. It used to be read the loud way: a
	 * toggled flag re-ran the load effect, the load raised the loading flag, and OpenDesktopView
	 * answers that flag by replacing the whole view with its skeleton. Everything on screen went
	 * with it -- the scroll position, an open lateral panel, anything typed and not yet saved --
	 * for a change the user had just made deliberately and was watching.
	 *
	 * A background read brings exactly the same data and leaves all of that in place.
	 */
	const handleButtonClick = () => {
		dispatch(getSparePartSales(token, { background: true }))
	}
	/**Get spare part request from back end */
	useEffect(() => {
		let isActive = true
		dispatch(getSparePartSales(token)).then(
			(result) => {
				let custom = result.Customer
				dispatch(loadSparePartByCustomer(custom.CodeSap))
			},
			(error) => {
				// Only a failed load lands here, not a failure further down the chain. Without the
				// request there is nothing to show -- typically it was deleted (IS2-45). The notice
				// travels with the navigation because this view, and its toaster, unmount. A user who
				// already left is not pulled back to the list.
				if (!isActive) return
				history.replace({
					pathname: '/sparepartsales',
					state: { notice: { message: error, variant: 'warning' } }
				})
			}
		)
		return () => {
			isActive = false
		}
	}, [dispatch, token, history])

	/**
	 * Keeps the tracking status current without the user reloading.
	 *
	 * A line item's tracking status changes for reasons outside this screen: the carrier reports
	 * an event and the backend records it. Nothing here was asking again, so the column kept
	 * showing whatever it said when the view was opened, and the only way to see the truth was a
	 * reload the user had no reason to suspect they needed.
	 *
	 * Two triggers, because one leaves a hole. Visibility covers the common case -- the tab is
	 * left open, the user does something else, comes back -- and costs nothing while nobody is
	 * looking. The interval covers the user who stays on the screen waiting for the shipment to
	 * move, which is the situation this came from. It runs only while the page is visible: an
	 * order left open in a forgotten tab should not keep asking all afternoon.
	 *
	 * Every refresh here is a background one, so it never raises the loading flag -- the view
	 * swaps itself for a skeleton when that flag is up, which would take the scroll position, any
	 * open panel and anything half-typed with it.
	 */
	useEffect(() => {
		const refresh = () => dispatch(getSparePartSales(token, { background: true }))

		let timer = null
		const start = () => {
			if (timer === null) timer = setInterval(refresh, TRACKING_REFRESH_INTERVAL_MS)
		}
		const stop = () => {
			if (timer !== null) {
				clearInterval(timer)
				timer = null
			}
		}

		const onVisibilityChange = () => {
			if (document.hidden) {
				stop()
				return
			}
			// Coming back is the moment the screen is most likely to be stale, so ask at once
			// rather than waiting out the rest of an interval that ran while nobody looked.
			refresh()
			start()
		}

		if (!document.hidden) start()
		document.addEventListener('visibilitychange', onVisibilityChange)

		return () => {
			stop()
			document.removeEventListener('visibilitychange', onVisibilityChange)
		}
	}, [dispatch, token])

	useEffect(() => {
		dispatch(loadInternalUsers())
	}, [dispatch])

	/**Open lateral panel for get equipment from SAP */
	const openLateralPanelSeries = () => {
		setAddLateralPanelConfig({ opened: !addLateralPanelConfig.opened })
	}

	/**
	 * Function to create spart part
	 * @param {*} service
	 * @param {*} position
	 */
	const onAddSparePart = (sparePartSale, sparePart, parentToken) => {
		return dispatch(addSpartPartInRequest(sparePartSale, sparePart, parentToken))
			.then((substitution) => {
				// IS2-43: the server replaces a discontinued part with its substitute and reports it.
				// Same notice as Warranties; there is no serie in a sale and nothing was anticipated.
				let message = buildAddFeedbackMessage(sparePart ? sparePart.Code : '', null, { Substitution: substitution }, null)
				if (message) {
					setToaster({ open: true, message, variant: 'info' })
					return
				}
				setToaster({ open: true, message: 'Spare part adding successfully in request', variant: 'success' })
			})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error) ? error : 'An error was generated while generating the add apare part',
					variant: 'warning'
				})
				// Re-raised after the notice so the panel can tell a failed add from a successful
				// one. It empties its fields only on success; swallowing the error here would
				// have it discard what the user typed exactly when they need it back.
				return Promise.reject(error)
			})
	}

	const onAddPartiality = (token, code, partialQuantity) => {
		return dispatch(addPartialityInRequest(token, code, partialQuantity))
			.then(() => {
				setToaster({ open: true, message: 'Spare part partiality adding successfully in request', variant: 'success' })
			})
			.catch((error) => {
				setToaster({
					open: true,
					message: !isNullOrEmpty(error.toString())
						? error.toString()
						: 'An error was generated while generating the add apare part partiality',
					variant: 'warning'
				})
			})
	}

	/**
	 * The carrier status of the line the panel is showing, read from the order rather than from
	 * the copy the panel was opened with.
	 *
	 * editLateralPanelConfig holds the row object as it looked when the user clicked through to
	 * it. That copy stops matching reality the moment the order changes underneath -- a
	 * background refresh carrying a delivery event is exactly that -- and the panel would then
	 * answer "is this delivered?" with a status the line no longer has. Opening the panel before
	 * the event arrives would produce the error toast for a shipment the list already shows as
	 * delivered.
	 *
	 * Only the status is taken this way. The panel's editable model still comes from the opened
	 * copy: replacing it wholesale would re-seed the panel on every refresh and discard whatever
	 * the user was editing inside it.
	 */
	const openedPartToken = editLateralPanelConfig.part && editLateralPanelConfig.part.Token
	const openedPartLiveStatus = (() => {
		const lines = (showSpareRequestSale.open && showSpareRequestSale.open.SpareParts) || []
		const line = openedPartToken ? lines.find((item) => item.Token === openedPartToken) : null
		return line ? line.Status : editLateralPanelConfig.part && editLateralPanelConfig.part.Status
	})()

	/**
	 * Check shipping by tracking number
	 * @param {*} sparePart
	 */
	const onCheckShipping = (carrierCode, trackingNumber, token) => {
		const part = editLateralPanelConfig.part
		// Read before the lookup: on the found path the line item's status is overwritten with
		// what the carrier just reported, and this question is about the state that made us run
		// the lookup in the first place.
		const wasDelivered = isDeliveredStatus(openedPartLiveStatus)

		return dispatch(checkShipping(carrierCode, trackingNumber.trim(), token)).then((result) => {
			if (result.outcome === TRACKING_LOOKUP.FOUND) {
				// A new object rather than a write into the one already held in state. Mutating it
				// worked only because every layer below shares the reference, which is the kind of
				// coupling that survives until someone adds a memo and then stops.
				//
				// The panel sees the new status either way: its effect depends on the carrier data
				// too, and that changes on every successful lookup, so it re-seeds from this object
				// regardless. What changes is that the object it re-seeds from is a new one, which
				// is what React is entitled to assume.
				setEditLateralPanelConfig({
					...editLateralPanelConfig,
					part: { ...part, Status: result.data.status }
				})
				return
			}

			// A delivered shipment has no details left to fetch: the backend deregisters it from
			// Trackingmore on delivery, so the lookup failing is the ordinary end of the cycle.
			// Announcing it as an error teaches the user to distrust a screen that is working.
			// The panel says so in its Detail View instead.
			if (wasDelivered) return

			setToaster({
				open: true,
				message: `The request was there but there is no information for this tracking number ${trackingNumber.trim()} to update`,
				variant: 'warning'
			})
		})
	}

	/**
	 * function to on update spare part in equipment
	 * @param {*} sparePart
	 */
	const onUpdateSpartPart = (sparePart, propertyToUpdate) => {
		return dispatch(updateSpareaPartDetail(token, sparePart, emailsInternalUsers, propertyToUpdate))
			.then(() => {
				// Exact match on purpose: 'Status' is what the Tracking Details status selector sends
				// (components/EditPanel.js). Its comment save sends 'COMMENTS' and must not refresh.
				// Normalizing either side to 'STATUS' breaks this refresh silently.
				if (propertyToUpdate === 'Status') {
					handleButtonClick()
				}
				if (propertyToUpdate === 'PoNumber') {
					dispatch(getSparePartSales(token)).then((result) => {
						let custom = result.Customer
						dispatch(loadSparePartByCustomer(custom.CodeSap))
					})
				} else if (CASCADED_PARENT_PROPERTIES.includes((propertyToUpdate || '').toUpperCase())) {
					// Position/Reference/Warehouse are cascaded to every child on the backend, but the PUT
					// response here only carries the edited (parent) row back — without a full refetch the
					// children keep showing their pre-cascade values until the user manually reloads the page.
					dispatch(getSparePartSales(token))
				}
			})
			.catch((error) => {
				setToaster({ open: true, message: error ? error : 'An error occurred while updating your spare part', variant: 'error' })
			})
	}

	const onBulkPoReference = (sparePartSaleToken, poNumber) => {
		setIsSavingBulkPoReference(true)
		return dispatch(bulkUpdatePoNumberReference(sparePartSaleToken, poNumber, null))
			.then(() => {
				setIsSavingBulkPoReference(false)
				setToaster({ open: true, message: 'PO # applied to all line items successfully', variant: 'success' })
			})
			.catch((error) => {
				setIsSavingBulkPoReference(false)
				setToaster({
					open: true,
					message: !isNullOrEmpty(error) ? error : 'An error occurred while applying PO # in bulk',
					variant: 'error'
				})
			})
	}

	const onRemoveSparePartDetail = (sparePart) => {
		setIdentifierSparePartDelete(sparePart.Token)
		return dispatch(removeSparePartDetail(sparePart, showSpareRequestSale ? showSpareRequestSale.open.Token : '', true))
			.then(() => {
				dispatch(getSparePartSales(token))
				setIdentifierSparePartDelete('')
				setToaster({ open: true, message: 'Spare part remove successfully', variant: 'success' })
			})
			.catch((error) => {
				setIdentifierSparePartDelete('')
				setToaster({ open: true, message: !isNullOrEmpty(error) ? error : 'An error to delete spare part', variant: 'error' })
			})
	}

	const onSaveSparePartRequest = (sparePartRequestsForm) => {
		return dispatch(updateSparePartSales(showSpareRequestSale ? showSpareRequestSale.open.Token : '', sparePartRequestsForm))
			.then(() => {
				setToaster({ open: true, message: 'Spare part request sales update successfully', variant: 'success' })
			})
			.catch((error) => {})
	}

	const onUpdateSparePartsPrices = (token) => {
		return dispatch(updateSparePartsPrices(token))
			.then(() => {
				setToaster({ open: true, message: 'Spare part request sales update successfully', variant: 'success' })
			})
			.catch((error) => {})
	}

	const onChangeLocation = (location) => history.push(location)

	/**Open lateral panel for change status spare part requests*/
	const openLateralPanelChangeStatus = (spartPart) => {
		setLateralPanelStatusConfig({ opened: !lateralPanelStatusConfig.opened, spartPart: spartPart })
	}

	/**Open lateral panel for import file spare parts */
	const openImportSparePart = () => {
		setLateralPanelImportFile({ opened: !lateralPanelImportFile.opened })
	}

	const onEditLateralPanelConfig = (part) => {
		setEditLateralPanelConfig({ opened: !editLateralPanelConfig.opened, part: part })
	}

	/**Open lateral panel for show send by provider */
	const openLateralPanelSendCustomer = (sparePartSale) => {
		setLateralPanelCustomerConfig({ opened: !lateralPanelCustomerConfig.opened, sparePartSale: sparePartSale })
	}

	/**
	 * On import file spare parte
	 */
	const onImportSpartPartList = (files) => {
		let sparePartFolio
		let sparePartOpen
		let open
		sparePartFolio = showSpareRequestSale
		if (sparePartFolio != null) {
			sparePartOpen = sparePartFolio.open
			if (sparePartOpen != null) open = sparePartOpen
			else open = null
		}
		dispatch(importSparePartFromBackend(token, files, open))
			.then((substitutions) => {
				openImportSparePart()
				// IS2-43: one notice listing the discontinued parts the server replaced, if any.
				let summary = buildImportSubstitutionSummary(substitutions)
				if (summary) {
					setToaster({ open: true, message: summary, variant: 'info' })
				}
				return Promise.resolve()
			})
			.catch((error) => {
				setToaster({ open: true, message: !isNullOrEmpty(error) ? error : 'An error to import references files', variant: 'error' })
			})
	}

	const onAddFilesInSparePartSales = (files, sparePartSale) => {
		return dispatch(addFilesSparePartSales(sparePartSale.Token, files)).catch((error) => {
			setToaster({ open: true, message: !isNullOrEmpty(error) ? error : 'An error occurred while adding file', variant: 'warning' })
		})
	}

	const onRemoveFilesInSparePartSales = (fileName, sparePartSale) => {
		return dispatch(removeFilesInSparePartSales(sparePartSale.Token, fileName)).catch((error) => {
			setToaster({ open: true, message: !isNullOrEmpty(error) ? error : 'An error occurred while remove file', variant: 'warning' })
		})
	}
	const onSaveEmailsContactNoPrice = (token, emailsContactNoPrice) => {
		return dispatch(updateEmailsContactNoPrice(token, emailsContactNoPrice))
			.then(() => {
				setToaster({ open: true, message: 'Emails saved successfully', variant: 'success' })
			})
			.catch((error) => {
				setToaster({ open: true, message: error ? error : 'Error saving emails', variant: 'error' })
			})
	}

	const onDownloadPackingListReport = (token) => {
		return dispatch(downloadPackingListReport(token))
			.then(() => {
				setToaster({ open: true, message: 'Download successfully', variant: 'success' })
			})
			.catch((error) => {
				setToaster({ open: true, message: error ? error : 'Error download report packing list', variant: 'error' })
			})
	}

	return (
		<>
			{
				<OpenDesktopView
					sparePartSales={showSpareRequestSale}
					sparePartsOptions={sparePartsOptions}
					isLoading={isLoading}
					onButtonSerieClick={openLateralPanelSeries}
					onAddSparePart={onAddSparePart}
					onAddPartiality={onAddPartiality}
					isSaving={isSaving}
					onSaveSparePartRequest={onSaveSparePartRequest}
					onRemoveSparePart={onRemoveSparePartDetail}
					identifierSparePartDelete={identifierSparePartDelete}
					userProfile={userProfile}
					onChangeLocation={onChangeLocation}
					openLateralPanelChangeStatus={openLateralPanelChangeStatus}
					isGetStock={isGetStock}
					openImportSparePart={openImportSparePart}
					onEditLateralPanelConfig={onEditLateralPanelConfig}
					openLateralPanelSendCustomer={openLateralPanelSendCustomer}
					onAddFilesInSparePartSales={onAddFilesInSparePartSales}
					onRemoveFilesInSparePartSales={onRemoveFilesInSparePartSales}
					onUpdateSpartPart={onUpdateSpartPart}
					onUpdateSparePartsPrices={onUpdateSparePartsPrices}
					onBulkPoReference={onBulkPoReference}
					isSavingBulkPoReference={isSavingBulkPoReference}
					isSavingDraft={isSavingDraft}
					onSaveEmailsContactNoPrice={onSaveEmailsContactNoPrice}
					onDownloadPackingListReport={onDownloadPackingListReport}
					isDownloadReport={isDownloadReport}
				/>
			}

			{lateralPanelImportFile.opened && (
				<PanelImportSparePart onCloseButtonClick={openImportSparePart} onImportSpartPartList={onImportSpartPartList} isSaving={isSaving} />
			)}

			<Edit
				onCloseButtonClick={onEditLateralPanelConfig}
				part={editLateralPanelConfig.part}
				trackingStatus={openedPartLiveStatus}
				onUpdateSpartPart={onUpdateSpartPart}
				userProfile={userProfile}
				status={showSpareRequestSale.open && showSpareRequestSale.open.Status}
				editLateralPanelConfig={editLateralPanelConfig}
				carrierData={carrierData}
				onCheckShipping={onCheckShipping}
				isGettingTrackingData={isGettingTrackingData}
				lateralPanelStatusConfig={lateralPanelStatusConfig}
				openLateralPanelChangeStatus={openLateralPanelChangeStatus}
			/>

			<EditSpareCustomer lateralPanelCustomerConfig={lateralPanelCustomerConfig} openLateralPanelSendCustomer={openLateralPanelSendCustomer} />

			<Toaster toasterOptions={toaster} onClose={() => setToaster({ open: false })} />
		</>
	)
}

export default OpenManual
